import { AuthService, Effect, IAction, ofType, SessionUser } from '@valhalla/core';
import { DataHttpService } from '@valhalla/data/http';
import { EMPTY, of, zip } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import * as actions from '../actions';
import { IUserSettingsState } from '../state';
import { UserSettingsEffectDependencies } from './dependency';

export const loadUserSettingsEffect: Effect<IAction, IAction, IUserSettingsState, UserSettingsEffectDependencies> = (
	actions$,
	state$,
	deps
) => {
	const server = deps.injector.get(DataHttpService);
	const sessionUser = deps.injector.get(SessionUser);

	return actions$.pipe(
		ofType(actions.FacadeUserSettingsAction.loadUserSettings),
		mergeMap(() => server.users.getSettings(sessionUser.userId)),
		map(data => actions.updateUserSettings(data)),
		catchError(e => {
			const errMsg = e.message || String(e);
			console.error(errMsg, e.error || e);
			return EMPTY;
		})
	);
};
